module.exports = __webpack_public_path__ + "static/media/5.e5c6f999.mp3";